import React from 'react';
import BEMHelper from 'react-bem-helper';
import { Icon, Popup } from 'semantic-ui-react';
import RegularTable from '../RegularTable';
import './RegularChallenges.scss';

const bem = BEMHelper({ name: 'RegularChallenges', outputIsString: true });

function RegularChallenges({
  myChallenges = false,
  groupId = null,
  isPrivate = null,
  hasPermission = null,
  onJoin = null,
}) {
  return (
    <div className={bem()}>
      {isPrivate && !hasPermission && groupId && (
        <div className={bem('empty-admin')}>
          <h2>
            <span onClick={onJoin}>Join</span> to see challenges!
          </h2>
        </div>
      )}

      {(!isPrivate || hasPermission || !groupId) && (
        <div>
          <div className="flex justify-between flex-wrap">
            <div className={bem('title')}>
              <Icon name="hourglass two" />
              <h5>Regular Challenges</h5>
              <Popup
                trigger={<i className="fas fa-question-circle ml-2 pointer" />}
                on="click"
                hoverable
                inverted
              >
                A regular challenge is a plan that can last up to 12 weeks that
                you can do with others.
              </Popup>
            </div>
          </div>
          <RegularTable myChallenges={myChallenges} groupId={groupId} />
        </div>
      )}
    </div>
  );
}
export default RegularChallenges;
